import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerContainer = styled.div`
  display: inline-block;
  width: ${props => {
    switch (props.size) {
      case 'sm': return '1rem';
      case 'lg': return '3rem';
      default: return '2rem';
    }
  }};
  height: ${props => {
    switch (props.size) {
      case 'sm': return '1rem';
      case 'lg': return '3rem';
      default: return '2rem';
    }
  }};
`;

const SpinnerCircle = styled.div`
  width: 100%;
  height: 100%;
  border: ${props => {
    const width = props.size === 'sm' ? '2px' : props.size === 'lg' ? '4px' : '3px';
    return `${width} solid ${props.theme.colors.muted}`;
  }};
  border-top-color: ${props => props.theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const Spinner = ({ size = 'md', className, ...props }) => {
  return (
    <SpinnerContainer size={size} className={className} {...props}>
      <SpinnerCircle size={size} />
    </SpinnerContainer>
  );
};

export default Spinner;



